<template>
  <Header />
  <div id="menu" class="container-fluid mt-5 pb-5">
    <center>
      <div class="row pb-5">
        <div class="col-lg-6 mt-5">
          <h2 class="headline w-75">UPDATE 18.02.2026</h2>
          <p style="text-align: left" class="test">
            The videos on Vimeo have been taken down. They are now available for download via pixeldrain.
          </p>
        </div>
        <div class="col-lg-6 mt-5">
          <h2 class="headline w-75">What is AOTCHRON?</h2>
          <p style="text-align: left" class="test">
            AOTCHRON is a fan edit of Attack on Titan that rearranges every scene in the anime in chronological order to create a new viewing experience.
            Flashbacks in their original place are either removed or shortened. Episodes end on new cliffhangers based on new editing.
          </p>
        </div>
        <div class="col-lg-6 mt-5">
          <h2 class="headline w-75">How to Watch</h2>
          <p style="text-align: left" class="test">
            The original 89 episodes (and the canon OVAs) are rearranged into 60 episodes available to stream via Vimeo on the Watch page.
          </p>
        </div>
        <div class="col-lg-6 mt-5">
          <h2 class="headline w-75">Why watch AOTCHRON?</h2>
          <p style="text-align: left" class="test">
            AOTCHRON is a completely unique way of rewatching Attack on Titan. The original story is very non linear with many big plotlines being revealed as the Anime goes along.
            With the chronological edit, every storyline occurs linearly and shows you every perspective simultaneously to give you a new perspective of the events of the show.
            I don't recommend watching AOTCHRON before watching the original Anime, as it would ruin most of the plot twists. This is not a replacement for watching the original show.
            Please support the original by buying the BluRay, streaming it on official streaming services or buying the manga.
          </p>
        </div>
        <div class="col-lg-6 mt-5">
          <h2 class="headline w-75">Moving Forward</h2>
          <p style="text-align: left" class="test">
            The entire edit was done by me over the course of about 8 months and I probably re-edited every episode about 20 times because this is my first time doing a fan edit and I'm a little stupid.
            (I was very starved for content after S4P2 ended so I decided to create my own new content instead of reading the manga)
            A friend of mine created this website, but I won't shout him out because he thinks he will be arrested if his name is attached to this :D 
          </p>
          <p style="text-align: left" class="test">  
            I didn't find the time to do quality control for every episode yet so there may be some editing errors. You can send me an E-Mail if you find any mistakes: aotchron@gmail.com
            I'll update old episodes if necessary and add the last episodes in english dub aswell.
          </p>
        </div>
      </div>
      <h2 style="margin-bottom: 1em" class="headline2">Overview Trailer</h2>
      <div class="embed-responsive embed-responsive-16by9">
        <iframe style="width: 100%; height: 100vh; max-width: 560px; max-height: 315px;" class="embed-responsive-item" src="https://www.youtube.com/embed/-w9dNV4AB4A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </div>
      <div class="mt-5">
        <h2 class="headline2">Full list of changes</h2>
        <b><u><p style="text-align: left; max-width: 50rem" class="mt-3 w-75">Rework (November 2023):</p></u></b>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Added scenes from the Final Chapters: Special 2 in AOTCHRON01, AOTCHRON58, AOTCHRON59</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Added Final Episode AOTCHRON60</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Fixed editing errors</p>
        <b><u><p style="text-align: left; max-width: 50rem" class="mt-3 w-75">Rework (October 2023):</p></u></b>
        <p style="text-align: left; max-width: 50rem" class="mt-3 w-75">- Episodes are now available as Vimeo streams instead of downloads</p>
        <p style="text-align: left; max-width: 50rem" class="mt-3 w-75">- Added custom episode title cards to every episode</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Added scenes from the Final Chapters: Special 1 in AOTCHRON07, AOTCHRON43, AOTCHRON44</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Added improved custom OPs and long versions of original OPs</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Fixed editing errors</p>
        <b><u><p style="text-align: left; max-width: 50rem" class="mt-3 w-75">General Edits:</p></u></b>
        <p style="text-align: left; max-width: 50rem" class="mt-3 w-75">- Rearranged every scene of the anime to occur chronologically</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">-> Including the "canon" OVAs (No Regrets, Ilses Notebook & Lost Girls)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">-> Flashbacks in their original place are either removed or shortened</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">-> Episodes end on new cliffhangers based on new editing (Some episodes end on the manga chapter endings, for example AOTCHRON07 ends like chapter 1, AOTCHRON52 ends like chapter 119)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Added Year subtitles for every time the year changes (Some of them are not officially confirmed so I took some creative liberties)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Added OST and other effects to create seemless transitions between previously unrelated scenes</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Removed "Information for Public Disclosure" mid cards and replaced the original Episode Title Screen</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Removed duplicate scenes and recaps</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- With a lot of flashbacks or scenes that have a character talking over a different scene I copied lip flap animation to create a new scene of a character talking on screen (Example: Annie's father's speech to Annie before she leaves Marley -> AOTCHRON07)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- New Episode names and descriptions (Mostly new names I came up with to fit the new context of the episode and some taken from manga chapter names)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Two-Parter episodes and bigger arcs are often combined into one long episode</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- OPs and EDs only appear in appropiate episodes and I also added some custom ones using the OST and covers</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Chose not to include or shorten some scenes that should be in a certain spot chronologically but don't add anything and break the flow</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- "AOTCHRON" title card in AOTCHRON02</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Custom Top 10 Cadets overview at the end of AOTCHRON13</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- My interpretation of what visions Eren actually sees when he kisses Historias hand (I'm not a manga reader)</p>
        <b><u><p style="text-align: left; max-width: 50rem" class="mt-3 w-75">Personal Edits:</p></u></b>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">(Some of these are kinda nitpicky and stupid but this is my fanedit so I'll do whatever I want)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S01E06 & S01E10: Shortened Armin's inner monologue because I don't like my guy talking down on himself so much</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S01E10: (DUB ONLY) Removed Armin saying "Those flowers weren't there before" because it's a wrong translation</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S01E11: Shortened Captain Rico's speech to Eren, because I think she's annoying</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S01E21 & S01E24: Shortened Eren's inner monologue when fighting Annie</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S02E04: Sped up the scene of Reiner & co staring at the Titan in the window to make it feel a little shorter than 5 hours of staring at it</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S02E07 (DUB ONLY) Shortened Eren's inner monologue when fighting the Reiner</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S02E06: Edited Reiner & Bertholdt's transformation scene to make the detail of their titan faces showing up for a few frames a bit more pronounced</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S02E07: Removed shots showing Eren & Reiner to have the full uncut sequence of Mikasas ODM action</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S02E11: Changed the editing with the split screen of Historia and Ymir</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S03E06: Removed Zachary weird torture scene (Characters still talk about it but I'd rather skip that scene when I'm rewatching)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S03E22: Removed Historia getting Ymirs memories after touching her letter (Keeps manga canon)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S04E20: Removed every part of Zeke & Eren talking in AOTCHRON9 to mostly show the events from Grishas perspective (Full episode takes place later)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S04E12: Removed some of Hanges inner monologue</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S04E13: Removed an unecessary exposition line from Jean when he sees Gabi</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S04E20: Keeping the TV version of Eren's crazy eyes while he's talking to Grisha</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- S04E25: Make Annie's force push shorter, remove Gabi's line before she starts crying, improved low detail animation scene where magath is talking to the group, remove Annie's "What about me?" (This line refers to another line from the manga that was not included so it makes no sense out of context)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- The Final Chapters: Special 1: Replaced Footsteps of Doom with Vogel im Käfig in the first Rumbling scene</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- The Final Chapters: Special 2: Added Linked Horizons "The Last Titan" OP</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- Some random changes to subtitles where I didn't like the phrasing in multiple episodes</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- (DUB ONLY) Replaced the DUB Titan screams with the SUB ones because I think they sound cooler (This was painful to edit but I couldn't stop once I commited to doing that)</p>
        <p style="text-align: left; max-width: 50rem"  class="mt-3 w-75">- (There may be a couple more small changes that I forgot to document)</p>
      </div>
    </center>
  </div>
</template>

<script>
import Header from "@/components/header";

export default {
  components: {
    Header,
  },
};
</script>

<style scoped>
.test{
  width: 75%;
  margin-top: 1em;
}
.row{
  border: 50px solid transparent;
  border-image: url("../assets/frame.png") 100 fill;
}

.headline {
    text-align: left;
    font-size: 30px;
}
.headline2 {
    position: relative;
    font-size: 30px;
    z-index: 1;
    overflow: hidden;
    text-align: center;
}
.headline2:before, .headline2:after {
    position: absolute;
    top: 51%;
    overflow: hidden;
    width: 50%;
    height: 2px;
    content: '\a0';
    border-radius: 15px;
    background-color: #292D2E;
}
.headline2:before {
    margin-left: -52%;
    text-align: right;
}
.headline2:after {
  margin-left: 2%;
}


@media only screen and (max-width: 600px) {
  .row{
  border: 0px solid transparent;
}
.embed-responsive-item{
  width: 85% !important;
  height: 100% !important;
}
.headline {
    position: relative;
    font-size: 18px;
    z-index: 1;
    overflow: hidden;
    text-align: center;
}
.headline:before, .headline:after {
    position: absolute;
    top: 51%;
    overflow: hidden;
    width: 50%;
    height: 2px;
    content: '\a0';
    border-radius: 15px;
    background-color: #292D2E;
}
.headline:before {
    margin-left: -52%;
    text-align: right;
}
.headline:after {
  margin-left: 2%;
}

.headline2 {
    font-size: 20px;
}

.test{
  font-size: 14px;
}

}

</style>
